import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { Alert, Form } from 'react-bootstrap';
import { Input, DateInput } from '../../common/components/formControls';
import validators from '../../common/services/validators';
import { withTranslation } from 'react-i18next';
import Localizations from '../localization';

const WeekForm = ({ error, handleSubmit, pristine, submitSucceeded, initialValues, t }) => {
	let id = initialValues && initialValues.id;

	return (
		<Form horizontal onSubmit={handleSubmit}>
			{error && <Alert bsStyle='danger'>{error}</Alert>}
			{submitSucceeded && pristine && <Alert bsStyle='success'>{t('Common_UpdateSuccess')}</Alert>}
			<Field name='name' component={Input} required horizontal type='text' label={t('Workshop_Week_Name')} labelCol={4} valueCol={8} />
			{id > 0 && <Localizations entityId={id} rootName={'workshopWeeks'} label={t('Workshop_Week_Name')} propertyName={'Name'} resourceName={`WorkshopWeek.${id}.Name`} isHtml={false} labelCol={4} valueCol={8}/>}

		</Form>
	);
};

export default reduxForm({ form: 'week' })(withTranslation()(WeekForm));